module.exports = __webpack_public_path__ + "img/app-apple-store.2928664f.svg";